export default "__VITE_ASSET__9cbvAob1__"